import { render, staticRenderFns } from "./swapV2.vue?vue&type=template&id=54c2d1ce&scoped=true"
import script from "./swapV2.vue?vue&type=script&lang=js"
export * from "./swapV2.vue?vue&type=script&lang=js"
import style0 from "./swapV2.vue?vue&type=style&index=0&id=54c2d1ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2d1ce",
  null
  
)

export default component.exports